<template>
    <div class="profile">
        <Navbar />
        <div class="mt-5 pt-5 kovatek-width container-fluid">
            <div class="row mt-md-4">
                <div class="col-12 col-xl-8">
                    <div class="row mx-md-2 mx-xl-4 px-xl-3" v-if="!loading">
                        <div class="col-12 col-md-7 d-md-flex">
                            <div>
                                <img :src="profileImage" class="rounded-circle img-height" />
                                <h4 class="kova-text mt-md-1" v-if="!!data.Username" :title="data.Username">
                                    {{ data.Username || 'oluwaseyijoshua' }}
                                </h4>
                            </div>
                            <div class="ml-md-3 px-0 text-center text-md-left">
                                <h3 class="font-weight-bolder kova-text ctrl-heading mb-0">
                                    {{ profileTitle }}
                                    <img
                                        class="mb-1 ml-1"
                                        style="height:22px;"
                                        src="../assets/kovatek/correct.svg"
                                        alt=""
                                    />
                                    <font-awesome-icon
                                        :icon="['fab', 'user-check']"
                                        class="user-check-col ml-2"
                                    ></font-awesome-icon>
                                </h3>
                                <!-- <h5 class="ctrl-heading1 mb-0" v-if="profileName">{{ profileTitle }}</h5> -->
                                <h6 class="text-uppercase my-0 text-intermediate ctrl-heading2">
                                    {{ profileLevel }}
                                </h6>

                                <div :class="profileName ? 'mt-2' : 'mt-3'">
                                    <span class="text-size2 font-weight-bolder" v-if="profileData.WorkRate">
                                        {{ workrate }}</span
                                    >/hr
                                    <br />
                                    <p class="text-size2">
                                        <font-awesome-icon
                                            style="font-size: 20px;"
                                            icon="map-marker-alt"
                                            class="text-dark mr-2"
                                        ></font-awesome-icon
                                        >{{ profileData.City }}, {{ profileData.Country }}
                                    </p>
                                </div>
                                <div class="d-none d-md-block">
                                    <router-link to="/devsignup/overview">
                                        <font-awesome-icon
                                            icon="pen"
                                            class="text-dark mr-2 pen-icon"
                                            style="font-size: 16px"
                                        ></font-awesome-icon>
                                        Update
                                    </router-link>
                                </div>
                            </div>
                        </div>

                        <div class="col text-center text-md-right">
                            <div>
                                <img class="mr-3 star" src="../assets/kovatek/best.svg" alt="" />
                                <span class="font-weight-bolder text-size rating">
                                    {{ profileData.SkillScore || '0.0' }}
                                </span>
                            </div>
                            <span class="ml-2 ctrl-size-2"> {{ profileData.Reviews }} reviews </span>
                            <p class="mt-0 mb-1 ctrl-heading1">Jobs Completed: {{ completedJobs.length }}</p>
                            <p class="mb-1 ctrl-heading1">
                                Team work: 0
                            </p>

                            <div class="mt-2 d-none d-md-block">
                                <button class="programming-task px-4 px-4 py-2 text-size2">
                                    Apply for Workspace
                                </button>
                            </div>
                        </div>

                        <div class="mt-3 d-flex justify-content-between d-md-none">
                            <router-link to="/devsignup/overview" class="mt-2">
                                <font-awesome-icon
                                    icon="pen"
                                    class="text-dark mr-2 pen-icon"
                                    style="font-size: 16px"
                                ></font-awesome-icon>
                                Update
                            </router-link>

                            <button class="programming-task px-4 px-4 py-2 text-size2">
                                Apply for Workspace
                            </button>
                        </div>
                    </div>
                    <div v-else class="mx-3">
                        <a-skeleton active avatar :paragraph="{ rows: 3 }" />
                    </div>
                </div>

                <div class="col mt-5 mb-4 my-xl-0">
                    <div class="bg-light p-2 border add-rounded shadow-sm mb-5 mx-3" style="position:sticky; top:85px;">
                        <div v-if="!loading" class="bg-kovatek m-2 m-md-1 m-lg-3 p-4 add-rounded">
                            <h3 class="text-white text-size1 text-center mb-2">
                                Assessment Profile
                            </h3>
                            <div class="row text-left">
                                <div class="col-8 text-white">
                                    <h4 class="text-white text-size2">Skill Score</h4>
                                </div>
                                <div class="col-4 text-white">
                                    <h4 class="text-white text-size2">
                                        {{ profileData.SkillScore ? `${profileData.SkillScore}%` : '-' }}
                                    </h4>
                                </div>
                            </div>
                            <div class="row text-left">
                                <div class="col-8 text-white">
                                    <p class="text-size3">Profile</p>
                                </div>
                                <div class="col-4 text-white">
                                    <p class="text-size3">{{ profileCount || '-' }}</p>
                                </div>
                            </div>
                            <div class="row text-left">
                                <div class="col-8 text-white">
                                    <p class="text-size3">Sprint Project Exercise</p>
                                </div>
                                <div class="col-4 text-white">
                                    <p class="text-size3">{{ profileData.TotalTests || '-' }}</p>
                                </div>
                            </div>
                            <div class="row text-left">
                                <div class="col-8 text-white">
                                    <p class="text-size3">Live Interview</p>
                                </div>
                                <div class="col-4 text-white">
                                    <p class="text-size3">
                                        {{ profileData.InterviewsCounts || '-' }}
                                    </p>
                                </div>
                            </div>
                            <button
                                class="see-more px-4 px-lg-5 py-2 mt-3 text-capitalize"
                                style="white-space:nowrap;"
                                @click="seeMore"
                            >
                                see more
                            </button>
                        </div>
                        <a-skeleton active v-else />
                    </div>
                </div>
            </div>

            <div class="row mt-n4">
                <div class="col-sm-12 col-md-12 col-lg-8 px-md-5">
                    <Profile :profileData="profilePropData" :loading="loading" />
                </div>
                <div class="col-sm-12 col-md-12 col-lg-4 pt-3 px-3 px-sm-4 px-md-3 px-lg-4">
                    <div style="position:sticky; top: 85px;" class="mx-md-4 mx-lg-0 px-md-1 px-lg-0">
                        <Notifications v-if="!loading" />
                        <div class="bg-light p-2 border add-rounded shadow-sm mb-5 mx-3" v-else>
                            <a-skeleton active :paragraph="{ rows: 3 }" />
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <!-- <Footer /> -->
    </div>
</template>

<script>
import Navbar from '@/components/Navbar.vue';
// import Footer from '@/components/Footer.vue';
import Profile from '@/components/Profile.vue';
import { computeExperienceLevel } from '@/helpers/compute';
import Notifications from '@/components/Notifications.vue';
import { levels } from '../data/resources';

import ProfileMixin from '../mixins/profile';

export default {
    name: 'profile',
    components: {
        Navbar,
        //  Footer,
        Profile,
        Notifications,
    },
    mixins: [ProfileMixin],
    data() {
        return {
            loading: true,
            profile: {},
            profileData: {},
            data: {},
            profileScore: {},
            error: '',
        };
    },
    computed: {
        profileCount() {
            let count = 0;
            for (let i in this.profileData) {
                if (this.profileData[i]) count++;
            }

            return count;
        },
        profileName() {
            return this.data.Firstname && this.data.Surname ? `${this.data.Firstname} ${this.data.Surname}` : '';
        },
        workrate() {
            if (this.data.HourRate && !this.$route.path.includes('settings')) {
                return `Hourly Rate: $${this.data.HourRate}`;
            }

            return levels.find(key => key.id == this.profileData.WorkRate)?.work_rate;
        },
        skillSet() {
            const { Speciality, OtherCoreTechstacks, CoreTechstack, Specializations } = this.profileData;

            const speciality = Speciality || '';
            const other_core_techstacks = OtherCoreTechstacks || [];
            let core_techstack = CoreTechstack || [];
            if (CoreTechstack && CoreTechstack.includes(',')) {
                core_techstack = (CoreTechstack || []).split(',').filter(key => key.length);
            }
            const specializations = Specializations || [];

            const skills = [speciality, ...core_techstack, ...other_core_techstacks, ...specializations];
            return Speciality ? [...new Set(skills)] : [];
        },
        profilePropData() {
            const { profileData, profileTitle, skillSet, portfolioLink, userImg } = this;
            return { ...profileData, ...this.data, profileTitle, skillSet, portfolioLink, userImg };
        },
    },
    async mounted() {
        try {
            await Promise.all([this.getProfile(), this.getAllSettings()]);
            window.scrollTo(0, 0);
            this.loading = false;
        } catch (e) {
            const { message } = e;
            console.error({ e, message });
            // if (message.includes('Network'))
            //     this.showError('Network Error!', 'Please check your internet connection and try again');
        }
    },
    methods: {
        seeMore() {
            this.$router.push('skill-score');
        },
        computeLevel(level) {
            return computeExperienceLevel(level);
        },
    },
};
</script>

<style scoped>
h3.kova-text,
h4.note-text {
    font-size: 20px;
}

h5.ctrl-heading1 {
    font-size: 16px;
}

.bg-kovatek {
    background-color: #20409a;
}
.bg-kovatek h3.text-size1 {
    font-size: 20px;
}
.btn-kovatek {
    background-color: #20409a;
    height: 50px;
    color: #fff;
    transition: 0.25s;
}
.btn-kovatek:hover {
    background-color: #06216d;
    color: #fff;
}
.input-height {
    height: 50px;
    font-size: 13px;
    width: 100%;
}
.submit-w {
    width: 300px;
}
.add-rounded {
    border-radius: 20px;
}
.img-height {
    width: 120px;
    height: 120px;
}
.text-intermediate {
    color: #bdbd50;
}
.text-size {
    font-size: 2.5em;
}
.text-size1 {
    font-size: 16px;
}
.text-size2 {
    font-size: 14px;
}
.text-size3 {
    font-size: 11px;
}
.see-more {
    background-color: transparent;
    border: solid 1.5px #fff;
    border-radius: 10px;
    color: #fff;
    transition: 0.25s;
}
.see-more:hover {
    background-color: #fff;
    color: #20409a;
}
.rating {
    color: #4bb38e;
}
.star {
    position: relative;
    bottom: 10px;
    height: 25px;
}
.programming-task {
    background-color: transparent;
    outline: 0;
    border: solid 2px #20409a;
    border-radius: 10px;
    color: #20409a;
    transition: 0.25s;
}
.programming-task:hover {
    background-color: #20409a;
    color: #fff;
}

@media screen and (min-width: 992px) and (max-width: 1325px) {
    .cont-size {
        width: 600px;
    }
    .img-height {
        width: 120px;
        height: 120px;
    }
}

@media screen and (min-width: 768px) and (max-width: 991px) {
    .cont-size {
        width: 600px;
    }
    .img-height {
        width: 120px;
        height: 120px;
    }
}

@media screen and (max-width: 767px) {
    .img-height {
        width: 115px;
        height: 115px;
    }
    .text-size {
        font-size: 1.8em;
    }
    .text-size2 {
        font-size: 16px;
    }
    .ctrl-heading {
        font-size: 1.4em;
    }
    .ctrl-heading1 {
        font-size: 1.2em;
    }
    .ctrl-heading2 {
        font-size: 0.9em;
    }
    .star {
        position: relative;
        bottom: 5px;
        height: 18px;
    }
}

@media screen and (max-width: 450px) {
    .cont-size {
        width: 100%;
    }

    .text-size2 {
        font-size: 12px;
    }
    .img-height {
        width: 85px;
        height: 85px;
    }
}
</style>
